import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';

import OptumLogo from '../../media/logo/OptumLogo';
import Divider from '../../ui/Divider/Divider';
import HelpModal from '../HelpModal/HelpModal';
import LanguageDropdown from '../LanguageDropdown/LanguageDropdown';

const StyledHeader = styled(Grid)({
  width: '100%',
  height: '84px',
  padding: '24px',
  boxSizing: 'border-box',
  position: 'relative',
});

const StyledDividerContainer = styled(Box)({
  position: 'absolute',
  left: 24,
  right: 24,
  bottom: 0,
});

type HeaderProps = {
  showLogo?: boolean;
  hideApplicationLanguageSelector?: boolean;
};

const Header = ({
  showLogo,
  hideApplicationLanguageSelector,
}: HeaderProps) => {
  const [showHelp, setShowHelp] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width: 539px)');

  return (
    <>
      <StyledHeader
        container
        direction="row"
        style={{ height: 'auto' }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems={isSmallScreen ? 'flexStart' : 'center'}
          direction={isSmallScreen ? 'column' : 'row'}
          style={{ height: 'auto' }}
          spacing={1}
          sx={{ flexGrow: 1 }}
        >
          {showLogo ? (
            <Grid>
              <OptumLogo
                width="111px"
                height="32px"
                aria-label="Optum logo"
              />
            </Grid>
          ) : null}
          <Grid>
            {/* Help link is disabled until we have some CMS capability to store content for each Line Of Business: https://optumfinancial.atlassian.net/browse/CC-1380 */}
            {/* <HelpButton onClick={() => setShowHelp((prevState) => !prevState)} /> */}
          </Grid>
          {!hideApplicationLanguageSelector ? (
            <Grid
              style={{ width: isSmallScreen ? '100%' : 'unset' }}
            >
              <LanguageDropdown />
            </Grid>
          ) : null}
        </Grid>

        <StyledDividerContainer>
          <Divider />
        </StyledDividerContainer>
      </StyledHeader>
      <HelpModal
        open={showHelp}
        onClose={() => {
          setShowHelp(false);
        }}
      />
    </>
  );
};

export default Header;
